// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".can-spinner{bottom:var(--x-gutter);opacity:0;pointer-events:none;position:fixed;right:var(--x-gutter);transition:opacity var(--hover-speed);width:4rem;z-index:180}.can-spinner.is-loading{opacity:1}.can-spinner__image,.can-spinner__video{display:block;height:auto;width:100%}@media (min-width:768px){.can-spinner{bottom:2rem;right:2rem;width:6rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
